import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 252.3 214.9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M143.5 184.8c.2-.2.3-.6 0-.9-.2-.2-.4-.2-.7-.1-48.7 19-104.1 7.9-141.7-28.5-.3-.2-.7-.2-.9 0s-.2.6 0 .8c20.8 30.8 53.5 51.5 90.2 57.3 2.4.4 5.8 1 7.1.4 21-8.5 35.5-18.9 46-29Z",
      style: {"fill":"#0094d9"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M243.7 101.8c3.2-13.5 7.5-30.7 8.4-61.3.5-16.3-.4-32.8-.7-39 0-.9-.8-1.5-1.7-1.5s-.5 0-.7.2l-92.2 53.6c-.8.4-1 1.4-.6 2.2.2.3.5.6.9.7l27.4 9c.8.3 1.5 1 1.7 1.8 1.8 8.3 2.8 16.7 2.8 25.2 0 29.9-9.9 58.9-28.3 82.4-12.8 16.4-29.1 29.5-47.8 38.5-.3.2-.5.6-.3.9.1.2.4.4.6.4 66-.9 115.3-47.6 130.6-113.2Z",
      style: {"fill":"#224099"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "5F-logo"}) } }